module.exports = __webpack_public_path__ + "9ca2b2bf0860e096981d24c49572497c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BW.svg
// module id = 91zh
// module chunks = 0